import { useMutation, useQueries } from '@tanstack/react-query';

import {
  QueueXeroTrialBalanceSyncParams,
  getXeroTrialBalanceSyncJobStatus,
  queueXeroTrialBalanceSync,
} from '~/services/ReportingService';

import { reportingQueryKeys } from './reportingQueryKeys';

const TERMINAL_XERO_SYNC_STATUSES = new Set(['completed', 'failed']);

export function useQueueXeroTrialBalanceSync() {
  return useMutation({
    mutationFn: async (params: QueueXeroTrialBalanceSyncParams) => {
      return await queueXeroTrialBalanceSync(params);
    },
  });
}

export function useGetXeroTrialBalanceSyncJobs(jobIds: Array<string>) {
  return useQueries({
    queries: jobIds.map((jobId) => ({
      queryKey: reportingQueryKeys.xeroTrialBalanceSyncJob(jobId),
      queryFn: async ({ signal }) => {
        return await getXeroTrialBalanceSyncJobStatus(jobId, { signal });
      },
      enabled: Boolean(jobId),
      retry: 1,
      refetchInterval: (query): number | false => {
        const status = query.state.data?.status;

        if (query.state.error) return false;
        if (!status) return 5000;

        return TERMINAL_XERO_SYNC_STATUSES.has(status) ? false : 5000;
      },
    })),
  });
}
